import { EditIcon } from "assets/icons/Edit";
import TrashIcon from "assets/icons/TrashIcon";
import { useCampaignsStore } from "screens/Campaigns/store";
import { ICampaign } from "screens/Campaigns/types";
import { formatDate } from "utils/formatDate";

export const CampaignCard = ({
  campaign,
  deleteCampaign
}: {
  campaign: ICampaign;
  deleteCampaign: (id: string) => void;
}) => {
  const { setIsOpenAddCampaignForm, setSelectedCampaign } = useCampaignsStore();

  return (
    <>
      <p>
        <span className="text-[#DADADA99]">Is active:</span>{" "}
        {campaign.is_active ? "Yes" : "No"}
      </p>
      <p>
        <span className="text-[#DADADA99]">Title:</span> {campaign.title}
      </p>
      <p>
        <span className="text-[#DADADA99]">Start date:</span>{" "}
        {formatDate(String(campaign.start_date))}
      </p>
      <p>
        <span className="text-[#DADADA99]">End date:</span>{" "}
        {formatDate(String(campaign.end_date))}
      </p>
      <div>
        <p className="text-[#DADADA99]">Main banner:</p>
        <img
          src={campaign.banner_url}
          alt="main-banner"
          className="w-[324px] h-[92px] object-contain bg-[#FFFFFF1A] rounded-[12px] overflow-hidden"
        />
      </div>
      <div>
        <p className="text-[#DADADA99]">Secondary banner:</p>
        <img
          src={campaign.secondary_banner_url}
          alt="secondary-banner"
          className="w-[246px] h-[200px] object-contain bg-[#FFFFFF1A] rounded-[12px] overflow-hidden"
        />
      </div>
      <div className="absolute top-0 right-0 flex gap-[8px] bg-[#111111] pl-2 pb-2">
        <button
          className="dapp-page--grid-item--action"
          aria-label="Open"
          onClick={(e) => {
            e.stopPropagation();
            setSelectedCampaign(campaign);
            setIsOpenAddCampaignForm(true);
          }}
        >
          <EditIcon width={14} height={14} />
        </button>
        <button
          className="dapp-page--grid-item--action-delete"
          aria-label="Open"
          onClick={(e) => {
            e.stopPropagation();
            deleteCampaign(campaign.id);
          }}
        >
          <TrashIcon width={16} height={16} />
        </button>
      </div>
    </>
  );
};
